export class UserCredentials {
  constructor(
    public id: number = null,
    public firstname: string = null,
    public lastname: string = null,
    public email: string = null,
    public roles: string[] = []
  ) {}
}
